import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss'],
    standalone: false
})
export class ListItemComponent implements OnInit {

  @Input() heading:any = null;
  @Input() title:any = null;
  @Input() icon:any = null;
  @Input() isFontAwesome: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
